module.exports = __webpack_public_path__ + "img/Flag_of_Kenya.35b3f238.svg";